import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import ww from "../assets/healthcare/WW.jpg";

import tick from "../assets/Tick.svg";
import wh from "../assets/healthcare/WH.png";
import l from "../assets/L.png";
import r from "../assets/R.png";
import g1 from "../assets/G1.png";
import g2 from "../assets/G2.png";
import g3 from "../assets/G3.png";
import g4 from "../assets/G4.png";
import g5 from "../assets/G5.png";
import g6 from "../assets/G6.png";
import devIcon from "../assets/F1.png";
import skillsIcon from "../assets/F2.png";
import techIcon from "../assets/F3.png";
import competitiveIcon from "../assets/F4.png";

import { Helmet } from "react-helmet-async";

import { useNavigate } from 'react-router-dom';

const Health = () => {
  const words = ["Today", "Tomorrow"];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000); // changes every 3s
    return () => clearInterval(timer);
  }, []);

  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleServicesDropdown = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const toggleIndustriesDropdown = () => {
    setIsIndustriesOpen(!isIndustriesOpen);
  };

  const toggleCompanyDropdown = () => {
    setIsCompanyOpen(!isCompanyOpen);
  };
  const [word, setWord] = useState('Today');

  useEffect(() => {
    const interval = setInterval(() => {
      setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const healthWords = ['Today', 'tomorrow']; // or any words you want
  const [healthIndex, setHealthIndex] = useState(0);
  const [healthFade, setHealthFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setHealthFade(false); // fade out
      setTimeout(() => {
        setHealthIndex(i => (i + 1) % healthWords.length);
        setHealthFade(true); // fade in
      }, 500);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/Contact#contact-section");
  };
  const features = [
    {
      text: "Revolutionizes healthcare training and recruitment.",
      width: 350,
      height: 150,
    },
    {
      text: "Cutting-edge tools ensure smooth hiring and professional growth.",
      width: 348,
      height: 240,
    },
    {
      text: "Streamlined hiring process reduces time and effort.",
      width: 280,
      height: 100,
    },
    {
      text: "Continuous learning opportunities for career advancement.",
      width: 368,
      height: 220,
    },
    {
      text: "Enhanced effectiveness of healthcare operations.",
      width: 348,
      height: 200,
    },
    {
      text: "Empowering providers with scalable tools for efficiency.",
      width: 328,
      height: 210,
    },
  ];

  const FeatureCard = ({ icon, title, description }) => (
    <div className="bg-green-50 rounded-2xl p-6 min-w-[300px] max-w-sm flex-shrink-0">
      <div className="mb-4">
        <img src={icon} alt="" className="h-10 w-10" />
      </div>
      <h3 className="font-semibold text-lg text-gray-900 mb-2">{title}</h3>
      <p className="text-sm text-gray-700 leading-relaxed">{description}</p>
    </div>
  );

  const featuress = [
    {
      icon: g1,
      title: "Streamlined hiring process",
      description:
        "Our platform lets healthcare providers post jobs, review applications and schedule interviews in one place, saving time and effort."
    },
    {
      icon: g2,
      title: "Empowering healthcare institutions",
      description:
        "We give healthcare institutions secure logins to manage hiring easily, ensuring qualified staff deliver top-quality patient care."
    },
    {
      icon: g3,
      title: "Flexible learning options",
      description:
        "We offer flexible learning options so healthcare professionals can balance ongoing education with their work schedules."
    },
    {
      icon: g4,
      title: "Comprehensive training programs",
      description:
        "We provides training programs to upskill healthcare professionals, offering industry-relevant courses accessible directly through our website."
    },
    {
      icon: g5,
      title: "Innovative recurring bookings",
      description:
        "Healthcare providers can efficiently schedule staff for specific shifts, ensuring optimal coverage and resource use to meet evolving healthcare demands."
    },
    {
      icon: g6,
      title: "Efficient financial transactions",
      description:
        "Our platform streamlines financial transactions with weekly salary payouts to medical professionals, ensuring transparency, consistency & smooth operations for all users."
    }
  ];

  const featuresss = [
    {
      title: "Comprehensive professional development",
      description:
        "Quick changes taking place in the healthcare industry. Our platform provides a large selection of Continuing Professional Development (CPD) courses and seminars to keep professionals up to date on the most recent innovations and best practices.",
      icon: devIcon,
      bg: "bg-[#C9F2FF]",
    },
    {
      title: "Enhancement of skills",
      description:
        "These programs aim to guarantee that healthcare providers can deliver excellent care by updating knowledge and improving skills. Professionals may stay up to date on the newest developments in healthcare technology and trends by enrolling in our CPD courses.",
      icon: skillsIcon,
      bg: "bg-[#F1E3FF]",
    },
    {
      title: "Cutting-edge technologies",
      description:
        "We equip providers with access to innovative healthcare technologies, improving diagnostics, treatment plans and operational workflows that directly impact care delivery.",
      icon: techIcon,
      bg: "bg-[#E2FFE2]",
    },
    {
      title: "Remaining competitive",
      description:
        "By investing in continuous learning and advanced tools, healthcare providers maintain a competitive edge in the ever-evolving medical industry and meet evolving patient needs.",
      icon: competitiveIcon,
      bg: "bg-[#FFF5D0]",
    },
  ];

  const FeatureCarrd = ({ icon, bg, title, description }) => (
    <div className="bg-white shadow-md rounded-xl p-6 font-poppins">
      <div className="w-12 h-12 flex items-center justify-center rounded-md mb-4" style={{ backgroundColor: bg }}>
        <img src={icon} alt={title} className="w-20 h-30 mr-10 md-30" />
      </div>
      <h3 className="font-semibold text-[15px] text-[#1c1c1c] mb-2 text-left">{title}</h3>
      <p className="text-[12px] text-[#3d3d3d] leading-relaxed text-left">{description}</p>
    </div>
  );

  const columns = 3; // number of columns in your grid

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  const ffeatures = [
    {
      text: "Revolutionizes healthcare training and recruitment.",
      width: 250,
      height: 190,
    },
    {
      text: "Cutting-edge tools ensure smooth hiring and professional growth.",
      width: 348,
      height: 150,
    },
    {
      text: "Streamlined hiring process reduces time and effort.",
      width: 275,
      height: 180,
    },
    {
      text: "Continuous learning opportunities for career advancement.",
      width: 368,
      height: 180,
    },
    {
      text: "Enhanced effectiveness of healthcare operations.",
      width: 348,
      height: 180,
      lift: true, //  Mark this card to move up
    },
    {
      text: "Empowering providers with scalable tools for efficiency.",
      width: 328,
      height: 180,
    },
  ];

  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };
  const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div >

      <Helmet>
        <title>Innovative Healthcare Solutions | Streamlined Hiring & Professional Development</title>
        <meta name="description" content="Streamline recruitment, empower staff with professional development, leverage cutting-edge technologies and improve patient care efficiency through automated processes and data-driven insights." />
        <meta name="keywords" content=" LENTERA healthcare services, digital healthcare tools, hospital workflow management, healthcare training programs." />
      </Helmet>
      <section className="bg-[#FFF6EF] font-poppins">
        <div className="mx-auto flex max-w-7xl flex-col-reverse items-center gap-8 px-4 py-16 md:flex-row">
          {/* Text Section */}
          <div className="w-full md:w-6/12 md:ml-10 text-center md:text-left">
            <p className="uppercase text-sm text-[#1c1c1c] mb-2 tracking-wide">
              Healthcare
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-[#1c1c1c] leading-snug mb-2">
              Healthcare with innovative <br /> solutions for a healthier

              of{" "}
              <span className="inline-block h-[60px] overflow-hidden relative align-middle">
                <div
                  className="transition-transform duration-700 ease-in-out"
                  style={{
                    transform: `translateY(-${index * 60}px)`,
                  }}
                >
                  {words.map((word, i) => (
                    <div
                      key={i}
                      className="h-[60px] text-[#F7BC2C] flex items-center text-[40px] sm:text-[44px] lg:text-[48px] font-bold"
                    >
                      {word}
                    </div>
                  ))}
                </div>
              </span>
            </h2>

            <p className="max-w-xl mx-auto md:mx-0 text-[15px] leading-relaxed text-gray-700">
              The approach allows institutions to streamline administrative tasks,
              improve data management and enhance student learning experiences.
            </p>
          </div>

          {/* Image Section */}
          <div className="w-full md:w-6/12 flex justify-center">
            <img
              src={ww}
              alt="Healthcare Illustration"
              className="w-4/5 md:w-[60%] lg:w-[70%]"
            />
          </div>
        </div>
      </section>

      <section className="px-4 py-8 mt-10">
        <div className="max-w-screen-xl mx-auto">
          <div className="bg-black text-white rounded-[50px] px-6 md:px-10 py-8 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">

            {/* Title */}
            <h2 className="text-2xl text-white md:text-3xl font-bold 
        bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-500 
        bg-[length:200%_200%] bg-clip-text text-transparent 
        animate-gradient"
            >
              Overview
            </h2>

            {/* Divider */}
            <div className="hidden md:block w-px h-10 bg-white" />

            {/* Description */}
            <p className="text-[16px] font-[400] leading-[28px]  text-[white]">
              Educational institutions can take advantage of advanced functionality,
              automate processes and offer <br className="hidden sm:block" /> seamless cross-platform access to educational
              resources by integrating specialized services like content <br className="hidden sm:block" />
              repositories, learning management systems and student information systems.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white font-poppins px-4 md:px-16 py-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">

          {/* Left Content */}
          <motion.div
            initial={{ x: -80, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: false }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="w-full lg:w-1/2 text-center lg:text-left"
          >
            <h2 className="text-[36px] md:text-[44px] font-semibold text-[#1C1C1C] leading-snug mb-6">
              Efficient hiring <br /> processes
            </h2>
            <p className="text-[16px] text-[#3D3D3D] leading-relaxed mb-4">
              Our platform revolutionizes the recruitment process by centralizing job postings,
              candidate applications and interview scheduling. This automation not only saves
              time but also ensures that only the most suitable candidates are matched with job openings.
            </p>
            <p className="text-[16px] text-[#3D3D3D] leading-relaxed">
              Advanced algorithms streamline the process, letting providers focus on patient care.
            </p>
          </motion.div>

          {/* Right Image */}
          <motion.div
            initial={{ x: 80, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: false }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="w-full lg:w-1/2 flex justify-center"
          >
            <img
              src={wh}
              alt="World Health Day"
              className="w-full max-w-md"
            />
          </motion.div>
        </div>
      </section>

      <section className="bg-[#1c1c1c] text-white font-poppins py-20 px-4 overflow-x-hidden">
        {/* Header */}
        <div className="max-w-6xl mx-auto text-center mb-16">
          <div className="inline-block bg-black text-white text-sm font-semibold px-4 py-2 rounded-full mb-6">
            LENTERA’S INNOVATION
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight mb-6">
            Revolutionizing healthcare training <br /> and recruitment
          </h1>
          <p className="text-base sm:text-[15px] text-gray-300 leading-relaxed">
            Lentera revolutionizes healthcare training and recruitment with cutting-edge tools,
            streamlining the hiring process and fostering continuous professional growth for
            enhanced operational efficiency.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="max-w-[1320px] mx-auto flex flex-wrap justify-center gap-7">
          {ffeatures.map((item, index) => {
            const row = Math.floor(index / 3);
            const fromRight = row % 2 === 0;

            return (
              <motion.div
                key={index}
                initial={{ x: fromRight ? 100 : -100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                className="bg-[#2e2e2e] rounded-[20px] px-6 py-6 flex flex-col items-start"
                style={{
                  width: `${item.width}px`,
                  height: `${item.height}px`,
                }}
              >
                <img src={tick} alt="tick" className="w-10 h-10 mb-4" />
                <p
                  className={`text-white text-[15px] leading-relaxed text-left ${item.tight ? "-mt-2" : "mt-0"
                    }`}
                >
                  {item.text}
                </p>

              </motion.div>
            );
          })}
        </div>
      </section>

      <section className="bg-white text-[#1c1c1c] py-20 px-6 md:px-10 lg:px-20">
        {/* Header Section */}
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-start lg:items-center mb-14">
          <div className="flex-1">
            <h2 className="font-semibold text-[42px] leading-[1.2]">
              How Lentera helps the <br className="hidden md:block" />
              healthcare sector
            </h2>
            <p className="mt-6 text-[16px] leading-[1.7] text-[#3d3d3d] max-w-[600px]">
              Lentera empowers the healthcare sector with real-time tracking and
              data-driven solutions to enhance efficiency, safety and patient care.
            </p>
          </div>

          {/* Arrows */}
          <div className="flex gap-4 mt-8 lg:mt-0">
            <button onClick={scrollLeft}>
              <img src={l} alt="left arrow" className="w-10 h-10 rounded-full border" />
            </button>
            <button onClick={scrollRight}>
              <img src={r} alt="right arrow" className="w-10 h-10 rounded-full border" />
            </button>
          </div>
        </div>

        {/* Scrollable Cards */}
        <div className="overflow-hidden">
          <div
            ref={scrollRef}
            className="flex gap-6 overflow-x-auto scroll-smooth hide-scrollbar pb-2"
          >
            {featuress.map((feature, index) => (
              <div
                key={index}
                className="min-w-[421.33px] max-w-[421.33px] bg-[#E9FFF1] rounded-[32px] p-6 flex-shrink-0"
                style={{ height: '273px' }}
              >
                <div className="flex flex-col justify-start h-full">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-12 h-12 mb-4"
                  />
                  <h3 className="text-[18px] font-semibold mb-2 leading-[1.4]">
                    {feature.title}
                  </h3>
                  <p className="text-[15px] text-[#3d3d3d] leading-[1.7]">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#f9f9f9] py-20 px-6 md:px-10 lg:px-20">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <h2 className="text-4xl font-bold text-[#1c1c1c] leading-tight mb-4">
            Enhancing the quality of healthcare
          </h2>
          <p className="text-[16px] text-[#3d3d3d]">
            We empower healthcare providers with smart tools and services that
            enhance care quality and improve patient outcomes.
          </p>
        </div>

        {/* Card Grid */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.3 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-center items-stretch"
        >
          {featuresss.map((item, idx) => (
            <motion.div
              key={idx}
              variants={fadeInUp}
              className="w-full max-w-[640px] h-[402px] bg-white rounded-[12px] shadow-md p-6 relative overflow-hidden mx-auto"
            >
              {/* Icon Box */}
              <div
                className={`absolute top-0 left-0 w-[75px] h-[75px] rounded-br-[20px] ${item.bg} flex items-center justify-center`}
              >
                <img src={item.icon} alt={item.title} className="w-15 h-15" />
              </div>

              {/* Card Content */}
              <div className="mt-20">
                <h3 className="text-[20px] font-semibold text-[#1c1c1c] mb-3 leading-snug">
                  {item.title}
                </h3>
                <p className="text-[#3d3d3d] text-[16px] leading-relaxed">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>
    </div>
  )
}

export default Health